export const footerInit = () => {
	const uls = document.querySelectorAll(".footer-section ul");
	uls.forEach((ul) => {
		const content = ul.innerHTML.replace(/\s/g, "");
		if (content.length === 0) {
			ul.parentElement.classList.add("footer-section-hidden");
		}
	});
};
